/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

return 5;
}

export default ["ie",[["a.m.","p.m."],u,["ante midí","pos midí"]],u,[["S","L","M","M","J","V","S"],["sol.","lun.","mar.","mer.","jov.","ven.","sat."],["soledí","lunedí","mardí","mercurdí","jovedí","venerdí","saturdí"],["So","Lu","Ma","Me","Jo","Ve","Sa"]],u,[["J","F","M","A","M","J","J","A","S","O","N","D"],["jan.","febr.","mar.","apr.","may","jun.","julí","aug.","sept.","oct.","nov.","dec."],["januar","februar","marte","april","may","junio","julí","august","septembre","octobre","novembre","decembre"]],u,[["a.C.","e.C."],u,["ante Crist","era Cristan"]],1,[6,0],["d.M.yy","d MMM y","d MMMM y","EEEE d MMMM y"],["HH:mm","HH:mm:ss","HH:mm:ss z","HH:mm:ss zzzz"],["{1} {0}",u,u,u],[","," ",";","%","+","-","E","×","‰","∞","NaN",":"],["#,##0.###","#,##0%","¤ #,##0.00;¤ -#,##0.00","#E0"],"EUR","€",u,{"JPY":["JP¥","¥"],"USD":["US$","$"]},"ltr", plural];
